import { Promise } from 'rsvp';

/**
  Helper to wait until a condition is met.

  In general you should NOT use this helper unless you have a special use case
  where Ember hooks/promises are not sufficient.

  Generally ripped from:
  https://github.com/emberjs/ember-test-helpers/blob/master/addon-test-support/%40ember/test-helpers/wait-until.js
*/

const TIMEOUTS = [0, 10, 20, 50, 70];
const MAX_TIMEOUT = 100;

/**
  Wait for the provided callback to return a truthy value.
  @param {Function} callback the callback to use for when waiting should stop
  @param {Object} [options] options used to override defaults
  @param {number} [options.timeout=1000] the maximum amount of time to wait
  @returns {Promise} resolves with the callback value when it returns a truthy value
*/
export default function waitUntil(callback, options = {}) {
  const timeout = options.timeout;
  return new Promise(function (resolve, reject) {
    let time = 0;
    function scheduleCheck(timeoutsIndex) {
      let interval = TIMEOUTS[timeoutsIndex];
      if (interval === undefined) {
        interval = MAX_TIMEOUT;
      }
      setTimeout(function () {
        time += interval;
        let value;
        try {
          value = callback();
        } catch (error) {
          reject(error);
        }
        if (value) {
          resolve(value);
        } else if (timeout && time >= timeout) {
          reject(new Error()); // eslint-disable-line unicorn/error-message
        } else {
          scheduleCheck(timeoutsIndex + 1);
        }
      }, interval);
    }
    scheduleCheck(0);
  });
}